import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import RatesCallout from './RatesCallout'

const PerDiemRatesCallout = () => {
  const { navigation } = useNavigation()

  return (
    <RatesCallout
      description={i18n.t('expenses_v2.settings.rate_configurations.per_diem_callout.description')}
      to={navigation.settings.expenses.rateConfigurations.fullPath()}
      cta={i18n.t('expenses_v2.settings.rate_configurations.per_diem_callout.cta')}
    />
  )
}

export default PerDiemRatesCallout
